import axios from 'axios';

const emailApi = axios.create({
  baseURL: "https://api.emailjs.com/api/v1.0"
});

export default emailApi;
